import { RootState } from '../types'

export const getUserSelector = (state: RootState) => state.user
